import { Room } from './getRooms'


export const URL = '/v2/pms/accomodations/:placeId/rooms/:roomId/'

export type Req = {
  number?: number
  floor?: number
  notes?: string
  room_category?: number
}

export type Resp = Room
